'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var maplibreGl = require('maplibre-gl');
var useResizeObserver = require('@react-hook/resize-observer');
var nthHookTheme = require('@narvar/nth-hook-theme');
require('./ResizableMap.module.css.js');
var icons = require('./icons.js');
var LocalDeliveryMap_module = require('./LocalDeliveryMap.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var useResizeObserver__default = /*#__PURE__*/_interopDefaultLegacy(useResizeObserver);

// this file is not tested with jest
const ResizableMap = ({
  maptilerKey,
  originLng,
  originLat,
  destinationLng,
  destinationLat,
  courierLng,
  courierLat,
  lastUpdated,
  isHPU = false
}) => {
  const [mapEl, setMapEl] = React.useState(null);
  const [maplibre, setMaplibre] = React.useState(null);
  React.useEffect(() => {
    if (!mapEl) return;
    if (maplibre) return;
    setMaplibre(new maplibreGl.Map({
      container: mapEl,
      interactive: false,
      style: `https://api.maptiler.com/maps/bright/style.json?key=${maptilerKey}`,
      trackResize: false // trackResize only resizes on window resize. This case is covered by useResizeObserver
    }));
  }, [mapEl, maplibre, maptilerKey]);
  useResizeObserver__default["default"](mapEl, () => {
    maplibre?.resize();
  });
  const [originEl, setOriginEl] = React.useState(null);
  const [originMarker, setOriginMarker] = React.useState(null);
  React.useEffect(() => {
    if (!maplibre) return;
    if (!originEl) return;
    if (originMarker) {
      if (typeof originLng === 'number' && typeof originLat === 'number') {
        // update existing marker
        originMarker.setLngLat([originLng, originLat]);
      } else {
        // remove exiting marker
        originMarker.remove();
        setOriginMarker(null);
      }
    } else if (typeof originLng === 'number' && typeof originLat === 'number') {
      // create missing marker
      const marker = new maplibreGl.Marker(originEl).setLngLat([originLng, originLat]).addTo(maplibre);
      setOriginMarker(marker);
    }
  }, [maplibre, originMarker, originEl, originLng, originLat]);
  const [destinationEl, setDestinationEl] = React.useState(null);
  const [destinationMarker, setDestinationMarker] = React.useState(null);
  React.useEffect(() => {
    if (!maplibre) return;
    if (!destinationEl) return;
    if (destinationMarker) {
      // update existing marker
      if (typeof destinationLng === 'number' && typeof destinationLat === 'number') {
        destinationMarker.setLngLat([destinationLng, destinationLat]);
      } else {
        // remove exiting marker
        destinationMarker.remove();
        setDestinationMarker(null);
      }
    } else if (typeof destinationLng === 'number' && typeof destinationLat === 'number') {
      // create missing marker
      const marker = new maplibreGl.Marker(destinationEl).setLngLat([destinationLng, destinationLat]).addTo(maplibre);
      setDestinationMarker(marker);
    }
  }, [maplibre, destinationMarker, destinationEl, destinationLng, destinationLat]);
  const [courierEl, setCourierEl] = React.useState(null);
  const [courierMarker, setCourierMarker] = React.useState(null);
  React.useEffect(() => {
    if (!maplibre) return;
    if (!courierEl) return;
    if (courierMarker) {
      if (typeof courierLng === 'number' && typeof courierLat === 'number') {
        // update existing marker
        courierMarker.setLngLat([courierLng, courierLat]);
      } else {
        // remove exiting marker
        courierMarker.remove();
        setCourierMarker(null);
      }
    } else if (typeof courierLng === 'number' && typeof courierLat === 'number') {
      // create missing marker
      const marker = new maplibreGl.Marker(courierEl).setLngLat([courierLng, courierLat]).addTo(maplibre);
      setCourierMarker(marker);
    }
  }, [maplibre, courierMarker, courierEl, courierLng, courierLat]);
  React.useEffect(() => {
    const bounds = new maplibreGl.LngLatBounds();
    let count = 0;
    if (typeof originLng === 'number' && typeof originLat === 'number') {
      bounds.extend(new maplibreGl.LngLat(originLng, originLat));
      count += 1;
    }
    if (typeof destinationLng === 'number' && typeof destinationLat === 'number') {
      bounds.extend(new maplibreGl.LngLat(destinationLng, destinationLat));
      count += 1;
    }
    if (typeof courierLng === 'number' && typeof courierLat === 'number') {
      bounds.extend(new maplibreGl.LngLat(courierLng, courierLat));
      count += 1;
    }
    maplibre?.fitBounds(bounds, {
      padding: 50,
      duration: 0
    });
    if (count === 1) {
      maplibre?.setZoom(14);
    }
  }, [maplibre, originLng, originLat, destinationLng, destinationLat, courierLng, courierLat]);
  const {
    bodytextDefaultNone,
    iconsPrimaryNone,
    buttonsPrimaryDefault
  } = nthHookTheme.useTheme();
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: LocalDeliveryMap_module["default"].mapContainer,
    ref: setMapEl,
    style: {
      height: '100%'
    }
  }, isHPU ? /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(icons.DropOffLogo, {
    ref: setOriginEl,
    s: iconsPrimaryNone
  }), /*#__PURE__*/React__default["default"].createElement(icons.DriverLogo, {
    ref: setCourierEl,
    s: buttonsPrimaryDefault
  })) : /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, originLat && originLng && /*#__PURE__*/React__default["default"].createElement(icons.RetailerLogo, {
    ref: setOriginEl,
    s: iconsPrimaryNone
  }), destinationLat && destinationLng && /*#__PURE__*/React__default["default"].createElement(icons.DropOffLogo, {
    ref: setDestinationEl,
    s: iconsPrimaryNone
  }), courierLat && courierLng && /*#__PURE__*/React__default["default"].createElement(icons.DriverLogo, {
    ref: setCourierEl,
    s: buttonsPrimaryDefault
  })), /*#__PURE__*/React__default["default"].createElement("div", {
    className: LocalDeliveryMap_module["default"].timestamp,
    style: {
      ...bodytextDefaultNone
    }
  }, lastUpdated));
};
var ResizableMap$1 = nthHookTheme.withThemeProvider(ResizableMap, {
  themeTokens: ['bodytextDefaultNone', 'iconsPrimaryNone', 'buttonsPrimaryDefault']
});

exports["default"] = ResizableMap$1;
